export default __webpack_public_path__ + "static/media/1842.38773718.png";